module.exports = __webpack_public_path__ + "img/anilin-herstellung.e99c7196.png";